<div class="star-rating"
     [class.star-rating--readonly]="readonly"
     [class.star-rating--small]="size === 'small'">
  @for (star of stars; track star.value) {
    <tidy-image
      [src]="star.src"
      class="star-rating__star"
      [class.star-rating__star--small]="size === 'small'"
      [class.star-rating__star--interactive]="!readonly"
      (click)="select(star.value)" />
  }
</div>
